import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../urls";
//axios
import axios from "../../utilies/axios";
//_________________________________________________

// GET =>  All ORDERS SERVICE
export const getOrdersService = createAsyncThunk(
  "orders/getOrdersService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.ordersURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// PUT => UPDATE ORDER SERVICE
export const updateOrderStatusService = createAsyncThunk(
  "orders/updateOrderStatusService",
  async (data, thunkAPI) => {
 
    try {
      const response = await axios.put(`${URLS.ordersURL}/${data?.id}`, {
        status: data?.status,
        _method: "PUT",
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
